import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { ChatModalService } from '../../core/services/chat-modal.service';

@Component({
  selector: 'app-chat-fab',
  templateUrl: './chat-fab.component.html',
  styleUrls: ['./chat-fab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatFabComponent implements OnDestroy {
  @ViewChild('fab', { static: true }) private fabRef!: ElementRef<HTMLButtonElement>;

  private dragging = false;
  private hasMoved = false;
  private startX = 0;
  private startY = 0;
  private offsetX = 0;
  private offsetY = 0;

  // Bind references for cleanup
  private boundMove = this.onPointerMove.bind(this);
  private boundUp = this.onPointerUp.bind(this);

  constructor(
    private readonly chatModalService: ChatModalService,
    private readonly cdr: ChangeDetectorRef,
  ) {}

  ngOnDestroy(): void {
    document.removeEventListener('pointermove', this.boundMove);
    document.removeEventListener('pointerup', this.boundUp);
  }

  /** Start drag on pointerdown */
  onPointerDown(event: PointerEvent): void {
    const el = this.fabRef.nativeElement;
    this.dragging = true;
    this.hasMoved = false;
    const rect = el.getBoundingClientRect();
    this.offsetX = event.clientX - rect.left;
    this.offsetY = event.clientY - rect.top;
    this.startX = event.clientX;
    this.startY = event.clientY;
    el.setPointerCapture(event.pointerId);
    document.addEventListener('pointermove', this.boundMove);
    document.addEventListener('pointerup', this.boundUp);
  }

  private onPointerMove(event: PointerEvent): void {
    if (!this.dragging) return;
    const dx = Math.abs(event.clientX - this.startX);
    const dy = Math.abs(event.clientY - this.startY);
    if (dx > 4 || dy > 4) this.hasMoved = true;
    if (!this.hasMoved) return;

    const el = this.fabRef.nativeElement;
    const x = Math.max(0, Math.min(window.innerWidth - el.offsetWidth, event.clientX - this.offsetX));
    const y = Math.max(0, Math.min(window.innerHeight - el.offsetHeight, event.clientY - this.offsetY));
    el.style.left = `${x}px`;
    el.style.top = `${y}px`;
    el.style.right = 'auto';
    el.style.bottom = 'auto';
  }

  private onPointerUp(): void {
    this.dragging = false;
    document.removeEventListener('pointermove', this.boundMove);
    document.removeEventListener('pointerup', this.boundUp);
    // If the user just clicked (no drag), navigate to chat
    if (!this.hasMoved) {
      this.open();
    }
  }

  open(): void {
    this.chatModalService.toggle();
  }

  onKey(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.open();
    }
  }
}
